import { MutationResult } from "@apollo/client/react";
import { SimpleToast } from "common/components/SimpleToast";
import { Spinner } from "common/components/Spinner";
import { parseErrorFromGraphql } from "common/graphql/utils";
import React from "react";

interface Props {
  loading: MutationResult["loading"];
  error: MutationResult["error"];
}

export const MutationLoadingOrError: React.FC<
  React.PropsWithChildren<Props>
> = ({ error, loading }) => (
  <>
    {loading && <Spinner />}
    {error && <SimpleToast message={parseErrorFromGraphql(error)} />}
  </>
);
